export default __webpack_public_path__ + "static/media/merchant.54c914ee.png";